import React from "react";
import { Table as Table2 } from '@devexpress/dx-react-grid-material-ui';
import { DatePicker } from 'material-ui-pickers';
import moment from 'moment';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";

const materialTheme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            root: {
                display: 'flex !important'
            }
        },
        MuiInput: {
            formControl: {
                fontSize: '1.6rem'
            },
            underline: {
                '&:after': {
                    borderBottom: '2px solid #2D323E'
                }
            }
        },
        MuiButton: {
            root: {
                fontSize: '1.4rem'
            },
            textPrimary: {
                color: '#3C4252'
            }
        },
        MuiTypography: {
            display1: {
                fontSize: '3.4rem'
            },
            body1: {
                fontSize: '1.4rem'
            },
            caption: {
                fontSize: '1.2rem'
            },
            subheading: {
                fontSize: '1.6rem'
            },
            colorPrimary: {
                color: '#3C4252'
            },
            headline: {
                fontSize: '1.6rem'
            }
        },
        MuiIconButton: {
            root: {
                fontSize: '1.2rem !important',
            }
        },
        MuiToolbar: {
            root: {
                backgroundColor: '#3C4252 !important'
            }
        },
        MuiPickersDay: {
            current: {
                color: '#3C4252'
            },
            day: {
                '&$selected': {
                    backgroundColor: '#3C4252 !important'
                }
            }
        },
        MuiPickersYear: {
            root: {
                '&$selected': {
                    fontSize: '2.4rem'
                }
            }
        }
    }
});

const DatePickerFilterCell = ({ column, filter, onFilter, minDate, maxDate }) => {
    // Date picker custom filter cell for grids.
    return (
        <Table2.Cell>
            <MuiThemeProvider theme={materialTheme}>
                <DatePicker
                    placeholder="Filter by date..."
                    keyboard
                    id="date-picker-dialog"
                    format="YYYY/MM/DD"
                    minDate={minDate}
                    maxDate={maxDate}
                    mask={value => (value ? [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/] : [])}
                    value={filter ? filter.value : null}
                    onChange={(event) => {
                        onFilter({ value: column.name === 'startDateFrom' ? moment(event).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : moment(event).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") })
                    }}
                    onInputChange={(event) => {
                        if (event.target.value === "") {
                            onFilter(null);
                        } else {
                            if (moment(event.target.value).isValid()) onFilter({ value: moment(event.target.value).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") })
                        }

                    }}
                    animateYearScrolling={false}
                />
            </MuiThemeProvider>
        </Table2.Cell>
    )
};

export default DatePickerFilterCell;


// WEBPACK FOOTER //
// ./src/main/content/common/data-table/DatePickerFilterCell.js